import { ChatBotUIDateSlot } from "@jugl-web/domain-resources/chat-bot/types";
import { PlainButton } from "@jugl-web/ui-components";
import { cx } from "@jugl-web/utils";
import format from "date-fns/format";
import { FC, useMemo } from "react";
import { ReactComponent as ArrowLeftIcon } from "./assets/arrow-left.svg";

interface TimeSlotPickerProps {
  day: Date;
  slots: ChatBotUIDateSlot[];
  onSelect: (slot: ChatBotUIDateSlot) => void;
  onGoBack: () => void;
}

export const TimeSlotPicker: FC<TimeSlotPickerProps> = ({
  day,
  slots,
  onSelect,
  onGoBack,
}) => {
  const formattedDay = useMemo<string>(
    () => format(day, "d MMMM, yyyy"),
    [day]
  );

  return (
    <div className="flex flex-col">
      {/* Header */}
      <div className="flex items-center gap-3">
        <PlainButton
          onClick={onGoBack}
          className={cx(
            "border-grey-300 flex h-8 w-8 shrink-0 items-center justify-center rounded-lg border border-solid",
            "text-dark cursor-pointer bg-white transition-colors",
            "hover:bg-grey-100 active:bg-grey-200"
          )}
        >
          <ArrowLeftIcon />
        </PlainButton>
        <span className="text-dark font-secondary text-[15px] font-medium leading-[20px]">
          {formattedDay}
        </span>
      </div>

      {/* List of available time slots */}
      <div className="jugl__custom-scrollbar mt-3 -mr-2 flex max-h-[224px] flex-col gap-1.5 overflow-y-auto pr-2">
        {slots.map((slot) => (
          <PlainButton
            key={slot.id}
            onClick={() => onSelect(slot)}
            className={cx(
              "flex h-10 shrink-0 items-center rounded-lg px-2",
              "font-secondary text-sm leading-[150%] text-[#4F4F4F]",
              "hover:bg-grey-100 active:bg-grey-200 transition-colors"
            )}
          >
            {format(slot.startTime, "h:mm a")}
          </PlainButton>
        ))}
      </div>
    </div>
  );
};
